import React from 'react';

import Bottom1Img from 'images/console-menu/bottom-1.svg';
import Bottom2Img from 'images/console-menu/bottom-2.svg';

import Logo from 'images/logo-notitle.png';
import NavItemLogo from './components/NavItemLogo/NavItemLogo';
import NavItemBtn from './components/NavItemBtn/NavItemBtn';

import './SideMenu.css';

const SideMenu = ({ routes }) => {
  return (
    <div className="c-side-menu">
      <div className="c-side-menu__top">
        <NavItemLogo src={Logo} path="/users" />
        {routes.map(item => (
          <NavItemBtn
            key={item.path}
            title={item.title}
            path={item.pathBase || item.path}
            icon={item.icon}
          />
        ))}
      </div>

      <div className="c-side-menu__bottom" style={{ display: 'none' }}>
        <NavItemBtn title="What evet" icon={Bottom1Img} />
        <NavItemBtn title="What evet" icon={Bottom2Img} />
      </div>
    </div>
  );
};

export default SideMenu;



// WEBPACK FOOTER //
// ./src/components/IterioApp/sideMenu/SideMenu.jsx